module.exports = __webpack_public_path__ + "media/images/athletes/3554-374ef92e7e0c3c53b79b2f5959f857f0.png";